import { AxiosRequestConfig, AxiosResponse } from 'axios';
import api from '@btcdirect/shared/src/composables/api/config/communicator-config';

/**
 * Retry the original call using the provided configuration.
 * @param config
 */
export function retry(config: AxiosRequestConfig): Promise<AxiosResponse> {
    try {
        return api(config);
    } catch (exception) {
        return Promise.reject(exception);
    }
}
